import Axios from 'axios';
import Qs from 'qs';

export default {

  // 标签列表
  list(
    community_id
  ) {
    return Axios.get('/community/api/admin/owners/tags', {
      params: {
        community_id
      }
    });
  },

  // 添加标签
  add(
    name
  ) {
    return Axios.post('/community/api/admin/owners/tags', {
      name
    });
  },

  // 编辑标签
  edit(
    id,
    name
  ) {
    return Axios.patch(`/community/api/admin/owners/tags/${id}`, {
      name
    });
  },

  // 删除标签
  del(
    id
  ) {
    return Axios.delete(`/community/api/admin/owners/tags/${id}`);
  },

  // 标签住户列表
  residentListPage(
    owner_tag_id,
    name,
    mobile,
    identity,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/owners/list-by-tag', {
      params: {
        owner_tag_id,
        filter: {
          name,
          mobile,
          identity
        },
        sort: {
          id: 'desc'
        },
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 标签添加住户
  addResident(
    tag_id,
    owner_info_ids,
    community_id
  ) {
    return Axios.post('/community/api/admin/owners/tags/interest', {
      tag_id,
      owner_info_ids,
      community_id
    });
  },

  // 标签移除住户
  delResident(
    id,
    owner_ids
  ) {
    return Axios.delete(`/community/api/admin/owners/del-tag/${id}`, {
      data: {
        owner_ids
      }
    });
  }

}